<template>
    <div id="price">
        <el-card shadow="never">
            <el-row>
                <el-col :span="8">
                    <el-button-group>
                        <el-button type="info" icon="el-icon-refresh" @click="loadType">刷新</el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入类型编号" v-model="input5" class="input-with-select" clearable></el-input>
                </el-col>
            </el-row>
            <el-row class="typeList">
                <el-col :span="24">
                    <el-table
                    v-loading ="loading"
                    element-loading-text = '加载中'
                    :data = 'tableData.filter( data => !input5 || data.typeCode.includes(input5))'
                    ref="filterTable"
                    height="400px"
                    border
                    style="width:100%">
                        <el-table-column
                            prop="typeCode"
                            label="类型编号"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="description"
                            label="类型名称"
                            show-overflow-tooltip
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="operation"
                                label="操作"
                                header-align="center"
                            >
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="设置" placement="bottom">
                                    <el-button @click.native.prevent="revise(scope.$index,tableData)" type="info" size="small" plain icon="el-icon-setting"  class="operateBtn">设置</el-button>
                                </el-tooltip>
                            </template>                                             
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    #price{
        .typeList{
            margin: 20px 0;
        }
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin],
    data(){
        return {
            input5:'',
            loading:false,
            tableData:[]
        }
    },
    created(){
        this.loadType();
    },
    methods:{
        //加载类型编号
        loadType(){
            this.loadTypes('findTypes').then((res) => {
                this.tableData = res;
            })
        },
        //修改价格
        revise(index,rows){
            let { typeCode } = rows[index]
            this.$router.push({
                path:'/system/addPrice',
                query:{
                    typeCode ,
                    index  
                }
            })
        }
    }
}
</script>
